module.exports = __webpack_public_path__ + "img/web4icon4.abcdffb5.png";